module.exports = __webpack_public_path__ + "static/ui-configurations@2x-9ccc081152c4aa1b14e8c2426d0b0080.png";